import en_default from "./en.js";
import ar_default from "./ar.js";
import az_default from "./az.js";
import bg_default from "./bg.js";
import bn_default from "./bn.js";
import bs_default from "./bs.js";
import ca_default from "./ca.js";
import cs_default from "./cs.js";
import cy_default from "./cy.js";
import da_default from "./da.js";
import de_default from "./de.js";
import el_default from "./el.js";
import es_default from "./es.js";
import et_default from "./et.js";
import eu_default from "./eu.js";
import fa_default from "./fa.js";
import fi_default from "./fi.js";
import fr_default from "./fr.js";
import gd_default from "./gd.js";
import gl_default from "./gl.js";
import he_default from "./he.js";
import hi_default from "./hi.js";
import hr_default from "./hr.js";
import hu_default from "./hu.js";
import id_default from "./id.js";
import it_default from "./it.js";
import ja_default from "./ja.js";
import ko_default from "./ko.js";
import lt_default from "./lt.js";
import lv_default from "./lv.js";
import mr_default from "./mr.js";
import nb_default from "./nb.js";
import ne_default from "./ne.js";
import nl_default from "./nl.js";
import nn_default from "./nn.js";
import oc_default from "./oc.js";
import pl_default from "./pl.js";
import pt_BR_default from "./pt-BR.js";
import pt_PT_default from "./pt-PT.js";
import ro_default from "./ro.js";
import ru_default from "./ru.js";
import sk_default from "./sk.js";
import sl_default from "./sl.js";
import sr_default from "./sr.js";
import sv_default from "./sv.js";
import te_default from "./te.js";
import th_default from "./th.js";
import tr_default from "./tr.js";
import uk_default from "./uk.js";
import vi_default from "./vi.js";
import zh_CN_default from "./zh-CN.js";
import zh_TW_default from "./zh-TW.js";
//#region src/core/i18n/locales/all.ts
/** Every built-in locale pack keyed by BCP 47 tag. */
const all = {
	en: en_default,
	ar: ar_default,
	az: az_default,
	bs: bs_default,
	bg: bg_default,
	bn: bn_default,
	ca: ca_default,
	cs: cs_default,
	cy: cy_default,
	da: da_default,
	de: de_default,
	el: el_default,
	es: es_default,
	et: et_default,
	eu: eu_default,
	fa: fa_default,
	fi: fi_default,
	fr: fr_default,
	gd: gd_default,
	gl: gl_default,
	he: he_default,
	hi: hi_default,
	hr: hr_default,
	hu: hu_default,
	id: id_default,
	it: it_default,
	ja: ja_default,
	ko: ko_default,
	lt: lt_default,
	lv: lv_default,
	mr: mr_default,
	nb: nb_default,
	nl: nl_default,
	nn: nn_default,
	ne: ne_default,
	oc: oc_default,
	pl: pl_default,
	"pt-BR": pt_BR_default,
	"pt-PT": pt_PT_default,
	ro: ro_default,
	ru: ru_default,
	sk: sk_default,
	sl: sl_default,
	sr: sr_default,
	sv: sv_default,
	te: te_default,
	th: th_default,
	tr: tr_default,
	uk: uk_default,
	vi: vi_default,
	"zh-CN": zh_CN_default,
	"zh-TW": zh_TW_default,
	pt: pt_BR_default,
	zh: zh_CN_default
};
/** BCP 47 tags for every pack in {@link all}. */
const localeTags = Object.keys(all);
//#endregion
export { all, localeTags };

//# sourceMappingURL=all.js.map